import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './store';
import { setupFetchInterceptor } from './utils/fetchInterceptor';
import './i18n';
import './styles/index.css';
import { RbacProvider } from './contexts/RbacContext';

// Setup global fetch interceptor to handle token expiration
setupFetchInterceptor();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <RbacProvider>
        <App />
      </RbacProvider>
    </BrowserRouter>
  </Provider>
);